import {Component, OnInit} from '@angular/core';
import {Station} from './station';
import {StationService} from './station.service';
import {ActivatedRoute, ParamMap} from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-station',
  templateUrl: './station.component.html',
  styleUrls: ['./station.component.css']
})
export class StationComponent implements OnInit {
  station: Station;

  constructor(private route: ActivatedRoute,
              private stationService: StationService) {
  }

  ngOnInit(): void {
    this.route
      .paramMap
      .switchMap((params: ParamMap) => this.stationService.getStationByName(params.get('label')))
      .subscribe((station: Station) => {
        this.station = station;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/station/station.component.ts